export default __webpack_public_path__ + "static/beatrice-03d47e56370f31330123c45a1c9c323c.png";